/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MailParamsDkvEInvoicingTemplateData } from '../../models/mail-params-dkv-e-invoicing-template-data';
import { ResponseObject } from '../../models/response-object';

export interface SendDkvEInvoicingMail$Params {
      body: MailParamsDkvEInvoicingTemplateData
}

export function sendDkvEInvoicingMail(http: HttpClient, rootUrl: string, params: SendDkvEInvoicingMail$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseObject>> {
  const rb = new RequestBuilder(rootUrl, sendDkvEInvoicingMail.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseObject>;
    })
  );
}

sendDkvEInvoicingMail.PATH = '/sendMail/dkv-einvoicing';
